if (!customElements.get('premiom-brands')) {
  customElements.define('premiom-brands', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const prefix = 'premiom-brand';
      const abort = new AbortController();
      const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: abort.signal });
      const marquee = this.querySelector(`.${prefix}-marquee`);
      const track = marquee?.querySelector(`.${prefix}-track`);
      const group = track?.querySelector(`.${prefix}-track-group`);
      if (!group || !group.children.length) return;
      this.setAttribute("data-ready", "");
      this.querySelector(".premiom-brand-controls").hidden = false;

      const controls = this.querySelectorAll(`[data-brand-direction]`);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(card => card.removeAttribute('data-shopify-editor-block'));
      // The visual copy must remain clickable; only exclude it from keyboard traversal.
      clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
      group.after(clone);

      let width = group.getBoundingClientRect().width;
      let position = 0;
      let velocity = 0;
      let hovered = false;
      let focused = false;
      let hoverDirection = null;
      let focusDirection = null;
      let clickDirection = null;
      let clickTimer;
      let frame;
      let lastTime;

      const paint = () => {
        if (width > 0) position = ((position % width) + width) % width;
        track.style.transform = `translate3d(${-position}px, 0, 0)`;
      };
      const step = (time) => {
        const dt = lastTime === undefined ? 0 : Math.min((time - lastTime) / 1000, 1 / 30);
        lastTime = time;
        if (!hovered && !focused && !document.hidden && width > 0) {
          const direction = clickDirection || hoverDirection || focusDirection;
          // Positive position moves the track left; previous moves it right.
          const target = direction ? (direction === 'previous' ? -width / 12 : width / 12) : width / 56;
          velocity += (target - velocity) * Math.min(dt * 6, 1);
          position += velocity * dt;
          paint();
        }
        frame = requestAnimationFrame(step);
      };
      const configureMotion = () => {
        cancelAnimationFrame(frame);
        clearTimeout(clickTimer);
        clickDirection = null;
        lastTime = undefined;
        position = 0;
        velocity = 0;
        marquee.scrollLeft = 0;
        paint();
        if (!reducedMotion.matches) frame = requestAnimationFrame(step);
      };
      listen(reducedMotion, 'change', configureMotion);
      configureMotion();

      const observer = new ResizeObserver(() => {
        const nextWidth = group.getBoundingClientRect().width;
        if (width > 0) position *= nextWidth / width;
        width = nextWidth;
        paint();
      });
      observer.observe(group);

      listen(marquee, 'pointerenter', (event) => {
        if (event.pointerType !== 'touch') hovered = true;
      });
      listen(marquee, 'pointerleave', () => { hovered = false; });
      listen(marquee, 'focusin', (event) => {
        focused = true;
        if (reducedMotion.matches) return;
        const card = event.target.closest(`.${prefix}-card`);
        if (!card) return;
        // Keep keyboard navigation in the original set, inside the visible viewport.
        marquee.scrollLeft = 0;
        const bounds = card.getBoundingClientRect();
        const viewport = marquee.getBoundingClientRect();
        if (bounds.left < viewport.left || bounds.right > viewport.right) {
          position = card.offsetLeft;
          paint();
        }
      });
      listen(marquee, 'focusout', (event) => {
        focused = marquee.contains(event.relatedTarget);
      });

      controls.forEach((control) => {
        const direction = control.dataset.brandDirection;
        listen(control, 'pointerenter', (event) => {
          if (event.pointerType !== 'touch') hoverDirection = direction;
        });
        listen(control, 'pointerleave', () => { hoverDirection = null; });
        listen(control, 'focus', () => {
          if (control.matches(':focus-visible')) focusDirection = direction;
        });
        listen(control, 'blur', () => { focusDirection = null; });
        listen(control, 'click', () => {
          if (reducedMotion.matches) {
            const card = group.querySelector(`.${prefix}-card`);
            marquee.scrollBy({ left: (direction === 'previous' ? -1 : 1) * (card.getBoundingClientRect().width + 12), behavior: 'instant' });
            return;
          }
          clearTimeout(clickTimer);
          clickDirection = direction;
          clickTimer = setTimeout(() => { clickDirection = null; }, 1200);
        });
      });

      this.cleanup = () => {
        cancelAnimationFrame(frame);
        clearTimeout(clickTimer);
        observer.disconnect();
        abort.abort();
        clone.remove();
        track.style.removeProperty('transform');
        this.removeAttribute('data-ready');
        this.querySelector('.premiom-brand-controls').hidden = true;
      };
      listen(this, 'shopify:block:select', (event) => {
        focused = true;
        const card = event.target.closest('.premiom-brand-card');
        if (card) { position = card.offsetLeft; paint(); }
      });
      listen(this, 'shopify:block:deselect', () => { focused = false; });
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}
